import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Signin from '@/components/Signin'
import Signup from '@/components/Signup'
import MealBook from '@/components/MealBook'
import Menu from '@/components/Menu'
import Trx from '@/components/Trx'
import Course from '@/components/Course'
import Privacy from '@/components/Privacy'
import Contact from '@/components/Contact'
import Company from '@/components/Company'
import Corporation from '@/components/Corporation'
import firebase from 'firebase'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: 'signin'
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/trx',
      name: 'Trx',
      component: Trx
    },
    {
      path: '/course',
      name: 'Course',
      component: Course
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/company',
      name: 'Company',
      component: Company
    },
    {
      path: '/book',
      name: 'MealBook',
      component: MealBook,
      meta: { requiresAuth: true }
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/corporation',
      name: 'Corporation',
      component: Corporation
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        next({
          path: '/signin',
          query: { redirect: to.fullPath }
        })
      }
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js